import React from "react";
import { ModernBreadcrumb, BreadcrumbItem } from "./ModernBreadcrumb";

type Props = {
  imageCover: string;
  eyebrow?: string;
  title: React.ReactNode;
  lead?: React.ReactNode;
  breadcrumbs?: BreadcrumbItem[];
  actions?: React.ReactNode;
  tall?: boolean;
  testId?: string;
};

export const PageHero: React.FC<Props> = ({
  imageCover,
  eyebrow,
  title,
  lead,
  breadcrumbs,
  actions,
  tall,
  testId = "page-hero",
}) => (
  <section
    className={`page-hero${tall ? " page-hero--tall" : ""} padding-x`}
    data-testid={testId}
  >
    <div className="page-hero__bg" style={{ backgroundImage: `url(${imageCover})` }} aria-hidden />
    <div className="page-hero__overlay" aria-hidden />
    <div className="page-hero__content padding-x is-layout-constrained">
      {breadcrumbs && breadcrumbs.length > 0 && (
        <div className="page-hero__breadcrumb">
          <ModernBreadcrumb items={breadcrumbs} onDark />
        </div>
      )}
      {eyebrow && <p className="page-hero__eyebrow">{eyebrow}</p>}
      <h1 className="page-hero__title">{title}</h1>
      {lead && <div className="page-hero__lead">{lead}</div>}
      {actions && <div className="page-hero__actions">{actions}</div>}
    </div>
  </section>
);
